import { Link } from 'react-router-dom';
import { TodoEntries } from './TodoList';
import type { TodoList } from './types';

/** On the home page: how many things wait and the first few; the rest on `/do-zrobienia`. */
export const HOME_ENTRIES = 6;

export function TodoCard({ todo }: { todo: TodoList }) {
  return (
    <section className="todo-home" aria-labelledby="todo-home-title" data-feature-id="todo.list">
      <h2 id="todo-home-title">Do zrobienia ({todo.count})</h2>
      <TodoEntries items={todo.items.slice(0, HOME_ENTRIES)} label="Do zrobienia" />
      <Link to="/do-zrobienia" className="todo-more">
        Pokaż wszystkie ({todo.count})
      </Link>
    </section>
  );
}
